import type {ButtonHTMLAttributes, ReactNode} from "react";

export type DsButtonVariant = "primary" | "secondary" | "outline" | "ghost";
export type DsButtonSize = "sm" | "md" | "lg";

export type DsButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: DsButtonVariant;
  size?: DsButtonSize;
  fullWidth?: boolean;
  children: ReactNode;
};

function btnClass(variant: DsButtonVariant, size: DsButtonSize, fullWidth?: boolean, className?: string) {
  return [
    "cc-ds-btn",
    `cc-ds-btn--${variant}`,
    `cc-ds-btn--${size}`,
    fullWidth ? "cc-ds-btn--full" : "",
    className || ""
  ].filter(Boolean).join(" ");
}

export function DsButton({
  variant = "primary",
  size = "md",
  fullWidth,
  className,
  type = "button",
  children,
  ...props
}: DsButtonProps) {
  return (
    <button type={type} className={btnClass(variant, size, fullWidth, className)} {...props}>
      {children}
    </button>
  );
}
